import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { MapPin, Phone, Mail } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_hotel-reserve-57/artifacts/fb0g6q0u_logo-yeni-amorium-copy.png';

export default function Footer() {
  const { t, language } = useApp();

  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: '#1F3A2E', color: 'white' }}>
      {/* Main Footer Content */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 1.5rem 2rem' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '3rem',
          marginBottom: '3rem',
        }}>
          {/* Brand */}
          <div>
            {/* Brand */}
            <img
              src={LOGO_URL}
              alt="Amorium Hotel"
              style={{ height: '44px', width: 'auto', objectFit: 'contain', filter: 'brightness(0) invert(1)', marginBottom: '16px', display: 'block' }}
            />
            <div style={{ width: '32px', height: '2px', background: '#B08D57', marginBottom: '12px' }} />
            <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.65)', lineHeight: 1.8, maxWidth: '260px' }}>
              {language === 'tr'
                ? "Kastamonu'nun kalbinde, doğayla bütünleşen lüks bir konaklama deneyimi."
                : 'A luxury accommodation experience integrated with nature in the heart of Kastamonu.'}
            </p>
            {/* Instagram Only */}
            <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
              <a
                href="https://www.instagram.com/amoriumhotel"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                style={{
                  display: 'flex', alignItems: 'center', gap: '8px',
                  background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)',
                  borderRadius: '8px', padding: '8px 14px', color: 'rgba(255,255,255,0.75)',
                  textDecoration: 'none', fontSize: '13px', fontWeight: 500,
                  transition: 'background 0.2s',
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(225,48,108,0.3)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.08)'}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
                </svg>
                @amoriumhotel
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{
              fontSize: '12px', fontWeight: 700, color: '#B08D57',
              textTransform: 'uppercase', letterSpacing: '0.1em',
              marginBottom: '16px',
            }}>
              {language === 'tr' ? 'Hızlı Bağlantılar' : 'Quick Links'}
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                { label: language === 'tr' ? '🏨 Amorium Hotel Ana Site' : '🏨 Amorium Hotel Main Site', href: 'https://amoriumhotel.com/', external: true },
                { label: language === 'tr' ? 'Ana Sayfa' : 'Home', href: '/' },
                { label: language === 'tr' ? 'Odalar & Suite\'ler' : 'Rooms & Suites', href: '/rooms' },
                { label: language === 'tr' ? 'Rezervasyon Yap' : 'Make Reservation', href: '/rooms' },
                { label: language === 'tr' ? 'Rezervasyonumu Sorgula' : 'My Booking', href: '/my-booking' },
                { label: language === 'tr' ? 'Politikalar' : 'Policies', href: '/privacy' },
              ].map(link => (
                link.external ? (
                  <a
                    key={link.href}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      fontSize: '13px',
                      color: 'rgba(255,255,255,0.75)',
                      textDecoration: 'none',
                      display: 'flex', alignItems: 'center', gap: '6px',
                      transition: 'color 0.2s',
                      fontWeight: 600,
                    }}
                    onMouseEnter={e => e.currentTarget.style.color = '#B08D57'}
                    onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
                  >
                    <span style={{ color: '#B08D57', fontSize: '10px' }}>›</span>
                    {link.label}
                  </a>
                ) : (
                  <Link
                    key={link.href + link.label}
                    to={link.href}
                    style={{
                      fontSize: '13px',
                      color: 'rgba(255,255,255,0.65)',
                      textDecoration: 'none',
                      display: 'flex', alignItems: 'center', gap: '6px',
                      transition: 'color 0.2s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.color = '#B08D57'}
                    onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.65)'}
                  >
                    <span style={{ color: '#B08D57', fontSize: '10px' }}>›</span>
                    {link.label}
                  </Link>
                )
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{
              fontSize: '12px', fontWeight: 700, color: '#B08D57',
              textTransform: 'uppercase', letterSpacing: '0.1em',
              marginBottom: '16px',
            }}>
              {language === 'tr' ? 'İletişim' : 'Contact'}
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <MapPin size={15} style={{ color: '#B08D57', flexShrink: 0, marginTop: '2px' }} />
                <div>
                  <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.75)', lineHeight: 1.6 }}>
                    Kumara Mah. Tekçam Mevkii No:7
                  </p>
                  <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.75)', lineHeight: 1.6 }}>
                    Budamış Köyü / Kastamonu, 37210
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Phone size={15} style={{ color: '#B08D57', flexShrink: 0 }} />
                <a
                  href="tel:+903662200909"
                  style={{ fontSize: '13px', color: 'rgba(255,255,255,0.75)', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#B08D57'}
                  onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
                >
                  +90 (366) 220 09 09
                </a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Mail size={15} style={{ color: '#B08D57', flexShrink: 0 }} />
                <a
                  href="mailto:info@amoriumhotel.com"
                  style={{ fontSize: '13px', color: 'rgba(255,255,255,0.75)', textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.color = '#B08D57'}
                  onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
                >
                  info@amoriumhotel.com
                </a>
              </div>
            </div>
          </div>

          {/* Reservation Info */}
          <div>
            <h4 style={{
              fontSize: '12px', fontWeight: 700, color: '#B08D57',
              textTransform: 'uppercase', letterSpacing: '0.1em',
              marginBottom: '16px',
            }}>
              {language === 'tr' ? 'Rezervasyon' : 'Reservations'}
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                { label: language === 'tr' ? '✓ Güvenli Online Ödeme' : '✓ Secure Online Payment' },
                { label: language === 'tr' ? '✓ Ücretsiz İptal İmkanı' : '✓ Free Cancellation' },
                { label: language === 'tr' ? '✓ En İyi Fiyat Garantisi' : '✓ Best Price Guarantee' },
                { label: language === 'tr' ? '✓ 7/24 Müşteri Desteği' : '✓ 24/7 Customer Support' },
              ].map((item, i) => (
                <p key={i} style={{ fontSize: '13px', color: 'rgba(255,255,255,0.65)', lineHeight: 1.6 }}>
                  {item.label}
                </p>
              ))}
            </div>
            {/* Payment methods */}
            <div style={{ marginTop: '16px' }}>
              <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.5)', marginBottom: '10px' }}>
                🔒 {language === 'tr' ? 'TEB Sanal POS ile güvenli ödeme' : 'Secure payment via TEB Virtual POS'}
              </p>
              <div data-testid="footer-payment-logos" style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                {/* Visa */}
                <div style={{
                  background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '6px', padding: '0 12px', height: '34px',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <span style={{ fontStyle: 'italic', fontWeight: 800, fontSize: '15px', letterSpacing: '0.02em', color: 'rgba(255,255,255,0.9)' }}>VISA</span>
                </div>
                {/* Mastercard */}
                <div style={{
                  background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '6px', padding: '0 12px', height: '34px',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                }}>
                  <svg width="30" height="19" viewBox="0 0 30 19">
                    <circle cx="10" cy="9.5" r="9" fill="#EB001B" />
                    <circle cx="20" cy="9.5" r="9" fill="#F79E1B" fillOpacity="0.9" />
                  </svg>
                </div>
                {/* TROY */}
                <div data-testid="footer-troy-logo" style={{
                  background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '6px', padding: '0 12px', height: '34px',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <img src="/logos/troy-white.png" alt="TROY" style={{ height: '15px', width: 'auto', display: 'block' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', padding: '1rem 1.5rem', background: 'rgba(0,0,0,0.15)' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', justifyContent: 'space-between' }}>
          <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)' }}>
            © {currentYear} Amorium Hotel. {language === 'tr' ? 'Tüm hakları saklıdır.' : 'All rights reserved.'}
          </p>
          <div style={{ display: 'flex', gap: '16px' }}>
            {[
              { label: language === 'tr' ? 'Gizlilik Politikası' : 'Privacy Policy', href: '/privacy' },
              { label: language === 'tr' ? 'Kullanım Şartları' : 'Terms of Use', href: '/terms' },
              { label: language === 'tr' ? 'Çerez Politikası' : 'Cookie Policy', href: '/cookies' },
            ].map((item) => (
              <Link
                key={item.href}
                to={item.href}
                style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)', textDecoration: 'none', transition: 'color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.8)'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.4)'}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
